var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recent-day-charging-pw"},[_c('pub-info-title',{attrs:{"title":'近一个月用户数量趋势',"isModal":true}}),_c('div',{ref:"ansLine",staticClass:"power-line-chart"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }